import React, { useEffect, useState } from "react";
import { Modal, Nav, Table, Image, Form, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import {
  MdAddCircleOutline,
  MdDelete,
  MdDeleteOutline,
  MdOutlineEdit,
  MdOutlineInfo,
} from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import {
  apiDeleteMobility,
  apiGetMobilities,
  apiSaveMobility,
  apiUpdateMobility,
} from "../../../api/ApiMobilities";
import ModalCropImage from "../../layout/ModalCropImage";
import { forceRefreshData } from "../../../redux/ReduxRefresh";

const ModalMobilities = (props) => {
  const { t } = useTranslation();
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const { id, show, handleClose, editModeForceMobility } = props;
  const [editMode, setEditMode] = useState(false);
  const initialState = {
    nom: "",
    email: "",
    procedure: "",
    localisation: id,
    cardPic: "",
  };
  const [state, setState] = useState(initialState);
  const [tabKey, setTabKey] = useState("informations");
  const [croppedImage, setCroppedImage] = useState("");
  const [deleteMode, setDeleteMode] = useState(false);
  const [mobilities, setMobilities] = useState([]);
  const [image, setImage] = useState("");
  const [showModalCrop, setShowModalCrop] = useState(false);
  const dispatch = useDispatch();

  const handleEditMode = (mobility) => {
    setTabKey("informations");
    if (mobility) {
      setState(mobility);
    }
    setEditMode(true);
  };

  const handleCloseEditMode = () => {
    setState(initialState);
    setCroppedImage("");
    setEditMode(false);
  };

  const handleDeleteMode = (mobility) => {
    if (mobility) {
      setState(mobility);
    }
    setDeleteMode(true);
  };

  const handleCloseDeleteMode = () => {
    setState(initialState);
    setDeleteMode(false);
  };

  const emptyImage = () => {
    setImage("");
    setCroppedImage("");
    setState({ ...state, cardPic: "" });
    const inputFile = document.getElementById("formBasicImage");
    if (inputFile) {
      inputFile.value = "";
    }
  };

  const onSelectedFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () => setImage(reader.result));
      reader.readAsDataURL(e.target.files[0]);
      setShowModalCrop(true);
    }
  };

  const handleCloseCrop = () => {
    setShowModalCrop(false);
  };

  const submitData = async () => {
    const myForm = new FormData();

    Object.keys(state).forEach((key) => {
      if (Array.isArray(state[key])) {
        state[key].forEach((element) => {
          myForm.append(key + "[]", element);
        });
      } else {
        myForm.append(key, state[key]);
      }
    });

    if (image) {
      myForm.append("image", croppedImage);
    }

    if (state._id) {
      const resUpdate = await apiUpdateMobility(state._id, myForm);
      if (resUpdate) {
        if (editModeForceMobility) {
          handleClose();
          dispatch(forceRefreshData());
        } else {
          setState(initialState);
          setCroppedImage("");
          setEditMode(false);
          recupData();
        }
      } else {
        console.log("error");
      }
    } else {
      const resSave = await apiSaveMobility(ReduxInstance._id, myForm);
      if (resSave) {
        setState(initialState);
        setCroppedImage("");
        setEditMode(false);
        recupData();
      } else {
        console.log("error");
      }
    }
  };

  const deleteMobility = async (idMobility) => {
    const res = await apiDeleteMobility(idMobility);
    if (res) {
      setState(initialState);
      setDeleteMode(false);
      recupData();
    } else {
      console.log("error");
    }
  };

  const recupData = async () => {
    const res = await apiGetMobilities(ReduxInstance._id, "filter[localisation]=" + id);
    setMobilities(res.data);
  };

  useEffect(() => {
    if (id) {
      setState({ ...state, localisation: id });
      recupData();
      if (editModeForceMobility) handleEditMode(editModeForceMobility);
    }
  }, [id, show]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Modal
      size="lg"
      show={show}
      onHide={() => {
        handleClose();
        setEditMode(false);
      }}
      className="componentRoomAdmin"
    >
      <Modal.Header closeButton>
        <Modal.Title>{t("admin.PageAdminLocalisations.modalMobilitesTitre")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {editMode ? (
          <>
            <Nav
              variant="tabs"
              activeKey={tabKey}
              onSelect={(selectedKey) => {
                setTabKey(selectedKey);
              }}
            >
              <Nav.Item>
                <Nav.Link eventKey="informations">
                  <MdOutlineInfo />
                  {t("admin.PageAdminLocalisations.menuNav1")}
                </Nav.Link>
              </Nav.Item>
            </Nav>
            <Form>
              {tabKey === "informations" && (
                <>
                  {croppedImage ? (
                    <div>
                      <div className="mt-2">{t("commun.form.label.image")}</div>
                      <Image src={URL.createObjectURL(croppedImage)} width={300} height={169} />
                      <span role="button" onClick={() => emptyImage()}>
                        <MdDelete size="1.5em" />
                      </span>
                    </div>
                  ) : state.cardPic ? (
                    <div>
                      <div className="mt-2">{t("commun.form.label.image")}</div>
                      <Image
                        width={300}
                        src={process.env.REACT_APP_URL_EXPRESS + "images/mobility/" + state.cardPic}
                      />
                      <span role="button" onClick={() => emptyImage()}>
                        <MdDelete size="1.5em" />
                      </span>
                    </div>
                  ) : (
                    <div>
                      <label className="mt-2">{t("commun.form.label.image")}</label>
                      <Form.Control type="file" accept="image/*" onChange={onSelectedFile} />
                    </div>
                  )}
                  <ModalCropImage
                    show={showModalCrop}
                    image={image}
                    handleClose={handleCloseCrop}
                    resetImage={emptyImage}
                    setImageCropped={setCroppedImage}
                    xRatio={600}
                    yRatio={338}
                  />
                  <label className="mt-2">{t("commun.form.label.intitule1")}</label>
                  <Form.Control
                    type="text"
                    name="nom"
                    placeholder={t("commun.form.placeholder.placeholder1")}
                    value={state.nom}
                    onChange={(e) => setState({ ...state, [e.target.name]: e.target.value })}
                  />
                  <label className="mt-2">{t("commun.form.label.email")}</label>
                  <Form.Control
                    type="text"
                    name="email"
                    placeholder={t("commun.form.placeholder.placeholderEmailRegister")}
                    value={state.email}
                    onChange={(e) => setState({ ...state, [e.target.name]: e.target.value })}
                  />

                  <label className="mt-2">{t("commun.form.label.intitule14")}</label>
                  <Form.Control
                    as="textarea"
                    type="text"
                    name="procedure"
                    placeholder={t("commun.form.placeholder.placeholder7")}
                    style={{ height: "200px" }}
                    value={state.procedure}
                    onChange={(e) => setState({ ...state, [e.target.name]: e.target.value })}
                  />
                </>
              )}
              <div style={{ marginTop: 50, marginRight: 8 }}>
                {!editModeForceMobility && (
                  <Button
                    style={{ marginRight: 8 }}
                    variant="primary"
                    onClick={handleCloseEditMode}
                  >
                    {t("commun.form.button.retour")}
                  </Button>
                )}
                <Button variant="success" onClick={submitData}>
                  {state._id ? t("commun.form.button.modifier") : t("commun.form.button.ajouter")}
                </Button>
              </div>
            </Form>
          </>
        ) : deleteMode ? (
          <div style={{ textAlign: "center" }}>
            <div>
              {t("admin.PageAdminLocalisations.modalMobilityDeleteText")}{" "}
              <strong>{state.nom}</strong>
            </div>
            <div style={{ marginTop: 10, marginRight: 8 }}>
              <Button style={{ marginRight: 8 }} variant="primary" onClick={handleCloseDeleteMode}>
                {t("commun.form.button.annuler")}
              </Button>
              <Button variant="success" onClick={() => deleteMobility(state._id)}>
                {t("commun.form.button.confirmer")}
              </Button>
            </div>
          </div>
        ) : (
          <>
            <span role="button" onClick={() => handleEditMode()}>
              <MdAddCircleOutline size="1.5em" />
              {t("admin.PageAdminLocalisations.modalEspacesButtonAjouterMobilite")}
            </span>
            <Table striped bordered hover className="stickyTable mt-2">
              <thead>
                <tr>
                  <th>{t("admin.PageAdminLocalisations.modalMobilitesTitreColonne1")}</th>
                  <th className="text-center">
                    {t("admin.PageAdminLocalisations.modalMobilitesTitreColonne4")}
                  </th>
                  <th className="text-center">
                    {t("admin.PageAdminLocalisations.modalMobilitesTitreColonne5")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {mobilities
                  .sort((a, b) =>
                    a.nom.toLowerCase() > b.nom.toLowerCase()
                      ? 1
                      : b.nom.toLowerCase() > a.nom.toLowerCase()
                      ? -1
                      : 0
                  )
                  .map((mobility) => (
                    <tr key={mobility._id}>
                      <td>{mobility.nom}</td>
                      <td className="text-center">
                        <MdOutlineEdit
                          size="1.5em"
                          role="button"
                          onClick={() => handleEditMode(mobility)}
                        />
                      </td>
                      <td className="text-center">
                        <MdDeleteOutline
                          size="1.5em"
                          role="button"
                          onClick={() => handleDeleteMode(mobility)}
                        />
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ModalMobilities;
